import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { HeaderInsuranceOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/header-insurance/header-insurance-wrapepr.component';

@Component({
  selector: 'app-header-insurance',
  templateUrl: './header-insurance.component.html',
  styleUrls: ['./header-insurance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderInsuranceComponent extends HeaderInsuranceOpenQuoteWrapper {
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }
}
